
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/quickEditEngine/components/styles/componentControlWrapper.scss.css.virtualfile';
        module.exports = {"quickEditComponentControlWrapper":"_quickEditComponentControlWrapper_1kup6_1"};